// Ce que l'avis de la fiche Radar retient du verdict (issue #169).

import type { CompatibilityResult } from '@ai-job-fit/engine/scoring'

/** La chose à vérifier : un point bloquant d'abord, sinon le premier écart
 *  majeur, sinon le premier mot-clé manquant. Une seule, en entier. */
export function aVerifier(r: Pick<CompatibilityResult, 'dealBreakers' | 'majorGaps' | 'missingKeywords'>): string | null {
  const premier = [...(r.dealBreakers ?? []), ...(r.majorGaps ?? []), ...(r.missingKeywords ?? [])].map((x) => String(x).trim()).find(Boolean)
  return premier ? premier.replace(/[.;,\s]+$/, '') : null
}
